import { useTranslation } from 'react-i18next'

export function getLegacyRedirectUrl (): string {
  const { i18n } = useTranslation()
  const languageQueryParam = 'language'
  const redirectUrl = new URL(`${process.env.REACT_APP_LEGACY_SKAL_BASE_URL as string}`)
  redirectUrl.searchParams.set(languageQueryParam, i18n.language)
  return redirectUrl.toString()
}
